<template>
  <!--==================
    component shows all operator reviews (admin, operator)
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <div v-if="user.role === 'admin'" class="form-group col-md-4 mb-4">
      <select @change="fetchReviews($event)" class="form-control form-control-sm">
        <option value="">--- select operator ---</option>
        <option v-for="operator in operators" :key="operator.id" :value="operator.id">
          {{ operator.companyName }}
        </option>
      </select>
    </div>

    <div v-if="!operatorReviews.reviews.length" class="alert alert-info col text-center" role="alert">
      <span class="font-italic">no review found for this account!</span>
    </div>

    <div v-if="operatorReviews.reviews.length" class="average-rating d-flex align-items-center col-md-6">
      <span><strong>Average rating</strong> ({{ operatorReviews.reviews.length }} reviews):</span>
      <div class="stars large">
        <i
          :class="
            $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) > 0 &&
            $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) <= 0.5
              ? 'sbi sbi--starhalf'
              : $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) > 0.5
              ? 'sbi sbi--star'
              : 'sbi sbi--starempty'
          "
        ></i>
        <i
          :class="
            $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) > 1 &&
            $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) <= 1.5
              ? 'sbi sbi--starhalf'
              : $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) > 1.5
              ? 'sbi sbi--star'
              : 'sbi sbi--starempty'
          "
        ></i>
        <i
          :class="
            $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) > 2 &&
            $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) <= 2.5
              ? 'sbi sbi--starhalf'
              : $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) > 2.5
              ? 'sbi sbi--star'
              : 'sbi sbi--starempty'
          "
        ></i>
        <i
          :class="
            $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) > 3 &&
            $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) <= 3.5
              ? 'sbi sbi--starhalf'
              : $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) > 3.5
              ? 'sbi sbi--star'
              : 'sbi sbi--starempty'
          "
        ></i>
        <i
          :class="
            $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) > 4 &&
            $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) <= 4.5
              ? 'sbi sbi--starhalf'
              : $options.filters.averageRate(operatorReviews.totalRate, operatorReviews.reviews.length) > 4.5
              ? 'sbi sbi--star'
              : 'sbi sbi--starempty'
          "
        ></i>
      </div>
      <span class="font-weight-bold">{{ operatorReviews.totalRate | averageRate(operatorReviews.reviews.length) }}</span
      >&nbsp;/ 5 stars
    </div>

    <div id="accordion">
      <div v-for="(review, index) in operatorReviews.reviews" :key="review.id" class="col">
        <div class="card-header px-0" :id="'heading-' + review.id">
          <h5 class="mb-0">
            <button
              @click="navigateReview($event)"
              class="btn btn-link col text-left"
              data-toggle="collapse"
              :data-target="'#collapse-' + review.id"
              aria-expanded="true"
              :aria-controls="'collapse-' + review.id"
            >
              <div class="d-flex align-items-center justify-content-between">
                <span
                  >{{ review.title }} | By <em>{{ review.fullName }}</em></span
                >
                <div class="d-flex align-items-center">
                  <div v-if="review.package" class="text-muted">
                    <span>Package: </span>
                    <span>{{ review.package }}</span>
                  </div>
                  <div class="stars">
                    <i
                      :class="
                        review.rate > 0 && review.rate <= 0.5
                          ? 'sbi sbi--starhalf'
                          : review.rate > 0.5
                          ? 'sbi sbi--star'
                          : 'sbi sbi--starempty'
                      "
                    ></i>
                    <i
                      :class="
                        review.rate > 1 && review.rate <= 1.5
                          ? 'sbi sbi--starhalf'
                          : review.rate > 1.5
                          ? 'sbi sbi--star'
                          : 'sbi sbi--starempty'
                      "
                    ></i>
                    <i
                      :class="
                        review.rate > 2 && review.rate <= 2.5
                          ? 'sbi sbi--starhalf'
                          : review.rate > 2.5
                          ? 'sbi sbi--star'
                          : 'sbi sbi--starempty'
                      "
                    ></i>
                    <i
                      :class="
                        review.rate > 3 && review.rate <= 3.5
                          ? 'sbi sbi--starhalf'
                          : review.rate > 3.5
                          ? 'sbi sbi--star'
                          : 'sbi sbi--starempty'
                      "
                    ></i>
                    <i
                      :class="
                        review.rate > 4 && review.rate <= 4.5
                          ? 'sbi sbi--starhalf'
                          : review.rate > 4.5
                          ? 'sbi sbi--star'
                          : 'sbi sbi--starempty'
                      "
                    ></i>
                  </div>
                </div>
              </div>
            </button>
          </h5>
        </div>

        <div
          :id="'collapse-' + review.id"
          class="collapse review-list"
          :aria-labelledby="'heading-' + review.id"
          data-parent="#accordion"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div class="review-info-left">
              <div class="">
                <span>{{ review.createdAt }} | By</span>
                <em>{{ review.fullName }}</em>
              </div>
              <div class="d-flex align-items-center">
                <span>Rating:</span>
                <div class="stars">
                  <i
                    :class="
                      review.rate > 0 && review.rate <= 0.5
                        ? 'sbi sbi--starhalf'
                        : review.rate > 0.5
                        ? 'sbi sbi--star'
                        : 'sbi sbi--starempty'
                    "
                  ></i>
                  <i
                    :class="
                      review.rate > 1 && review.rate <= 1.5
                        ? 'sbi sbi--starhalf'
                        : review.rate > 1.5
                        ? 'sbi sbi--star'
                        : 'sbi sbi--starempty'
                    "
                  ></i>
                  <i
                    :class="
                      review.rate > 2 && review.rate <= 2.5
                        ? 'sbi sbi--starhalf'
                        : review.rate > 2.5
                        ? 'sbi sbi--star'
                        : 'sbi sbi--starempty'
                    "
                  ></i>
                  <i
                    :class="
                      review.rate > 3 && review.rate <= 3.5
                        ? 'sbi sbi--starhalf'
                        : review.rate > 3.5
                        ? 'sbi sbi--star'
                        : 'sbi sbi--starempty'
                    "
                  ></i>
                  <i
                    :class="
                      review.rate > 4 && review.rate <= 4.5
                        ? 'sbi sbi--starhalf'
                        : review.rate > 4.5
                        ? 'sbi sbi--star'
                        : 'sbi sbi--starempty'
                    "
                  ></i>
                </div>
                <span class="font-weight-bold">{{ review.rate }}</span
                >&nbsp;/ 5 stars
              </div>
            </div>
            <div class="review-info-right">
              <a
                v-if="user.role == 'operator' && !review.reply"
                @click="replyBox($event)"
                href="#"
                :for="'reply-box-' + review.id"
                class="reply"
              >
                Reply
              </a>
              <a
                v-if="user.role == 'admin'"
                @click="editReview($event)"
                class="mr-4"
                href="#"
                :data-id="review.id"
                :data-index="index"
              >
                Edit
              </a>
              <a
                v-if="user.role == 'admin'"
                @click="removeReview($event)"
                class="mr-4"
                href="#"
                :data-id="review.id"
                :data-index="index"
              >
                Delete
              </a>
            </div>
          </div>
          <div class="review">
            <strong>{{ review.title }}</strong>
            <p class="mt-2">{{ review.description }}</p>
          </div>
          <div v-if="review.reply" class="operator-reply">
            <div class="d-flex justify-content-between mb-3">
              <span><em>Reply</em></span>
              <a
                v-if="user.role == 'operator'"
                @click="removeReply($event)"
                class="mr-4"
                href="#"
                :data-id="review.reply.id"
                :data-index="index"
                >delete reply</a
              >
            </div>
            <p class="mt-2">{{ review.reply.description }}</p>
          </div>
          <div :id="'reply-box-' + review.id" class="operator-reply" style="display: none">
            <form v-if="!review.reply" @submit.prevent="publishReply" :id="'reply-form-' + review.id">
              <span class="reply">Reply to this review</span>

              <input type="hidden" name="review" :value="review.id" />
              <div class="form-group">
                <textarea class="form-control form-control-sm" rows="4" name="reply"></textarea>
              </div>
              <div class="form-group">
                <button class="btn btn-sm btn-success mr-2 ml-2" type="submit">
                  <span>Publish Reply</span>
                  <span class="ml-2" style="display: none">submitting...</span>
                </button>
                <button
                  @click="replyBox($event)"
                  type="button"
                  class="btn btn-sm btn-secondary ml-2"
                  :for="'reply-box-' + review.id"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- reciew edit modal -->
    <app-review-edit-modal></app-review-edit-modal>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import ReviewEditModal from "@/components/ReviewEditModal.vue";

export default {
  name: "OperatorReview",

  components: {
    "app-review-edit-modal": ReviewEditModal,
  },

  data() {
    return {
      activeReplyBox: null,
    };
  },

  computed: {
    ...mapGetters(["user", "operators", "operatorReviews"]),
  },

  mounted() {
    this.getOperatorReviews();
    this.fetchOperators();
  },

  methods: {
    ...mapActions([
      "deleteReview",
      "fetchOperators",
      "fetchOperatorReviews",
      "hideBarLoading",
      "hideSpinnerLoading",
      "showSpinnerLoading",
      "addReviewReply",
      "removeReviewReply",
    ]),

    async publishReply(e) {
      this.showSpinnerLoading();

      const formId = e.target.getAttribute("id");

      $("#" + formId + " button span").toggle();

      const formData = new FormData(document.getElementById(formId));
      const detail = Object.fromEntries(formData);
      detail.review = parseInt(detail.review);

      await this.addReviewReply(detail)
        .then((res) => {
          this.fetchOperatorReviews(this.user.id);

          if (res.data) {
            $.alert("reply published successfull");
            $("#" + this.activeReplyBox).toggle();
          }
          this.hideSpinnerLoading();

          $("#" + formId + " button span").toggle();
          $("#" + formId).hide();
        })
        .catch((error) => {
          if (!error.response) {
            this.hideSpinnerLoading();
            $("#" + formId + " button span").toggle();
            $.alert("please check you internet connection!");
          } else if (error.response.status == 400) {
            this.hideSpinnerLoading();
            $("#" + formId + " button span").toggle();
          }
        });
    },

    removeReview(e) {
      e.preventDefault();

      let id = e.target.getAttribute("data-id");
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this review?",
        buttons: {
          confirm: () => {
            dP.deleteReview({ id, tag: "operator" });
          },
          cancel: () => {},
        },
      });
    },

    editReview(e) {
      e.preventDefault();

      const tourIndex = e.target.getAttribute("data-index");
      const payload = this.operatorReviews.reviews[tourIndex];

      this.$modal.show("review-edit-modal", payload);
    },

    removeReply(e) {
      e.preventDefault();

      let id = e.target.getAttribute("data-id");
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this reply?",
        buttons: {
          confirm: () => {
            dP.removeReviewReply(id);
          },
          cancel: () => {},
        },
      });
    },

    async fetchReviews(e) {
      let operator = e.target.value;

      this.fetchOperatorReviews(operator);
    },

    replyBox(e) {
      e.preventDefault();
      let id = e.target.getAttribute("for");
      this.activeReplyBox = id;

      $("#" + id).toggle();
    },

    navigateReview(e) {
      setTimeout(() => {
        $("html, body").animate(
          {
            scrollTop: $(e.target).offset().top - 40 + "px",
          },
          500
        );
      }, 1000);
    },

    getOperatorReviews() {
      if (this.user.role === "operator") {
        this.fetchOperatorReviews(this.user.id);
      } else {
        this.hideBarLoading();
      }
    },
  },
};
</script>
